import React from "react";
import { Box, Typography } from "@mui/material";

function SectionTimestampNotice({
  label = "Timestamp",
  value,
  colorSet = "info",
  hidden = false,
}) {
  if (hidden || !value) return null;

  const paletteByType = {
    info: {
      bg: "#e3f2fd",
      border: "#2196f3",
      title: "#1565c0",
      text: "#0d47a1",
      icon: "🔵",
    },
    warning: {
      bg: "#fff3e0",
      border: "#ff9800",
      title: "#e65100",
      text: "#bf360c",
      icon: "🟠",
    },
    success: {
      bg: "#e8f5e9",
      border: "#4caf50",
      title: "#2e7d32",
      text: "#1b5e20",
      icon: "🟢",
    },
    neutral: {
      bg: "#f5f5f5",
      border: "#bdbdbd",
      title: "#424242",
      text: "#212121",
      icon: "⚪",
    },
  };

  const palette = paletteByType[colorSet] || paletteByType.info;

  const formattedValue = new Date(value).toLocaleString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });

  return (
    <Box
      sx={{
        mt: 1,
        p: 2,
        mb: 2,
        bgcolor: palette.bg,
        borderRadius: 1,
        border: `1px solid ${palette.border}`,
      }}
    >
      <Typography
        variant="body2"
        sx={{ color: palette.title, fontWeight: 600 }}
      >
        {palette.icon} {label}:
      </Typography>

      <Typography
        variant="body2"
        sx={{ color: palette.text, mt: 0.5 }}
      >
        {formattedValue}
      </Typography>
    </Box>
  );
}

export default SectionTimestampNotice;